import { SavedSearchResponse } from '@doda/api-client/aspida/@types';
import { FeaturedSearchConditionQuery } from 'components/SearchSideBar/types';
import { convertToJobOfferKindValue } from '../convert';

interface ArgumentType {
  savedSearchCondition?: SavedSearchResponse | undefined;
  featuredSearchCondition?: FeaturedSearchConditionQuery | undefined;
  query: string | undefined;
}

/**
 * id配列を取得
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.query クエリパラメータ
 * @returns {string[]} id配列
 */
export const getInitialIdList = ({
  savedSearchCondition,
  featuredSearchCondition,
  query,
}: ArgumentType) => {
  // 保存した検索条件
  if (savedSearchCondition) return savedSearchCondition.jobOfferKind ?? '';

  // 特集枠検索条件
  if (featuredSearchCondition)
    return featuredSearchCondition.jobOfferKind ?? '';

  // クエリから取得した検索条件
  return convertToJobOfferKindValue(query) ?? '';
};
